import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

interface StatCardProps {
  imageSrc: string;
  label: string;
  subLabel?: string;
  value: number | string;
}

const StatCard: React.FC<StatCardProps> = ({
  imageSrc,
  label,
  value,
  subLabel,
}) => {
  return (
    <Card
      elevation={0}
      sx={{ borderRadius: 2, width: "100%", boxShadow: "0 0 0 1px #e0e0e0" }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" mb={1}>
          <Box mr={1} display="flex" alignItems="center">
            <img src={imageSrc} alt={label} width={18} height={18} />
          </Box>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Box>

        <Box mr={1} mt={"20px"} display="flex" alignItems="center">
          <Typography variant="h5" fontWeight="bold">
            {typeof value === "number" ? value.toLocaleString() : value}
          </Typography>
          <Typography pl="6px" fontSize={"12px"} color="text.secondary">
            {subLabel}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
